<template>
  <authenticated-layout :back-route="{ name: 'institutionDashboard', params: { institutionId, tab: 'students' } }"
                        :breadcrumbs="breadcrumbItems">

    <user-detail-content
      :user-id="userId"
      :tenant-id="tenantId"
      :institution-id="institutionId"
      route-name="institutionUserDetail"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import UserDetailContent from "@/components/Users/UserDetailContent.vue";
import {Institution} from "@YenzaCT/sdk";
import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";
import {useGlobalStore} from "@/store";

const route = useRoute();
const { executeApi } = useApiCall();
const store = useGlobalStore();

const userId = computed(() => route.params.userId as string);
const institutionId = route.params.institutionId as string;
const tenantId = computed(() => route.params.tenantId as string);
const canAccessSpecificTenant = store.canAccessSpecificTenant(route.params.tenantId as string);

const institution = ref<Institution>();

const breadcrumbItems = computed(() => [
  { text: "My Schools", to: { name: "schoolsDashboard" } },
  { text: institution.value?.tenantMeta?.title || "",
    to: canAccessSpecificTenant ? { name: "schoolsDashboardWithTenant",
      params: { tenantId: institution.value?.tenant } } : {
      name: "schoolsDashboardWithoutTenant"
    }},
  {
    text: institution.value?.title || "Institution",
    to: { name: "institutionDashboard", params: { institutionId } }
  },
  { text: "User Details" }
]);

async function fetchInstitution() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.institution.get(institutionId);
    return response.data;
  });
  if (result) {
    institution.value = result;
  }
}

onMounted(async () => {
  await fetchInstitution();
});
</script>
